<template>
  <div class="vue-magnify">
    <div class="preview-box" @mousemove="move($event)" @mouseout="out" ref="previewBox">
      <img width="100%" :src="previewImg" alt="">
      <div class="hover-box" ref="hoverBox"></div>
    </div>
    <div class="detailsLeft">
      <div class="detailSmall">
        <div id="jcarousel" class="jcarousel-panel" data-jcarousel="true">
          <ul ref="zoomNext" class="fn-clear" style="left: 0px; top: 0px;">
              <li :class="idx == onIdx ? 'click' : ''" v-for="(n,idx) in listImg" @mousemove="moves(n,idx)" @mouseout="play" :key="idx">
                  <a href="javascript:void(0);">
                    <img :src="n" alt="">
                  </a>
                </li>
              </ul>
            </div>
          <a class="jcarousel-control-prev inactive" @click="prev">‹</a>
          <a class="jcarousel-control-next inactive" @click="next">›</a>
      </div>
  </div>

  <div class="zoom-box" v-show="zoomVisiable" ref="zoomBox">
      <img :src="zoomImg" alt="" ref="bigImg">
    </div>
  </div>
</template>

<script>
const offset = function(el) {
  let top = el.offsetTop;
  let left = el.offsetLeft;
  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }
  return {
    left: left,
    top: top
  };
};

export default {
  name: "vue-magnify",
  props: {
    listImg: {
      type: Array,
      default: () => ["http://www.yos168.com/lots-web/images/product/NoPicture.png"]
      }
  },
  data() {
    return {
      zoomVisiable: false,
      hoverVisiable: false,
      previewImg: this.listImg.length > 0 ? this.listImg[0] : "",
      zoomImg: this.listImg.length > 0 ? this.listImg[0] : "",
      onIdx: 0,
      timer: null,
    };
  },
  created () {
    this.play()
  },
  destroyed (){
    this.stop()
  },
  methods: {
    out() {
      this.zoomVisiable = false;
      this.play()
    },
    move(ev) {
      this.stop();
      this.init();
      const scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
      const scrollY = document.documentElement.scrollTop || document.body.scrollTop;
      let moveX = ev.clientX + scrollX;
      let moveY = ev.clientY + scrollY;
      let offsetLeft = offset(this.oPreviewBox).left;
      let offsetTop = offset(this.oPreviewBox).top;
      let left = moveX - offsetLeft - this.houverWidth / 2;
      let top = moveY - offsetTop - this.houverHeight / 2;
      let maxWidth = this.pWidth - this.houverWidth;
      let maxHeight = this.pWidth - this.houverHeight;
      left = left < 0 ? 0 : left > maxWidth ? maxWidth : left;
      top = top < 0 ? 0 : top > maxHeight ? maxHeight : top;
      let percentX = left / maxWidth;
      let percentY = top / maxHeight;
      this.oHoverBox.style.left = left + "px";
      this.oHoverBox.style.top = top + "px";
      this.oBigImg.style.left = percentX * (this.bWidth - this.imgWidth) + "px";
      this.oBigImg.style.top = percentY * (this.bHeight - this.imgHeight) + "px";
      this.$emit("move", ev);
      this.zoomVisiable = true;
    },
    moves(n, idx) {
      this.stop()
      if (n) {
        this.previewImg = n;
        this.zoomImg = n;
        this.onIdx = idx;
      }
    },
    init() {
      this.oHoverBox = this.$refs.hoverBox;
      this.oPreviewBox = this.$refs.previewBox;
      this.oBigImg = this.$refs.bigImg;
      this.imgBox = this.$refs.zoomBox;
      this.houverWidth = this.oHoverBox.offsetWidth;
      this.houverHeight = this.oHoverBox.offsetHeight;
      this.pWidth = this.oPreviewBox.offsetWidth;
      this.pHeight = this.oPreviewBox.offsetHeight;
      this.imgWidth = this.oBigImg.offsetWidth;
      this.imgHeight = this.oBigImg.offsetHeight;
      this.bWidth = this.imgBox.offsetWidth;
      this.bHeight = this.imgBox.offsetHeight;
    },
    autoPlay () {
      this.onIdx++;
      if (this.onIdx === this.listImg.length) {
        this.onIdx = 0
      }
      
      if (this.onIdx > 4) {
        this.$refs.zoomNext.style.left = '-400px';
      } else {
        this.$refs.zoomNext.style.left = '0px';
      }
      this.previewImg = this.listImg[this.onIdx];
      this.zoomImg = this.listImg[this.onIdx];
    },
    play () {
      if(this.listImg.length <= 1) return
      this.timer = setInterval(this.autoPlay, 5000)
    },
    stop () {
      clearInterval(this.timer)
      this.timer = null
    },
    prev(){
      if(this.listImg.length <= 4) return
      this.$refs.zoomNext.style.left = '0px';
    },
    next(){
      if(this.listImg.length  <= 4) return
      this.$refs.zoomNext.style.left = '-400px';
    }
  }
};
</script>
<style lang="less" scoped>
.vue-magnify {
  position: relative;
  .preview-box {
    width: 410px;
    height: 410px;
    border: 1px solid #fff;
    position: relative;
    text-align: center;
    margin-left: 16px;
    &:hover .hover-box {
      display: block;
    }
    img {
      width: 410px;
      height: 410px;
    }
    .hover-box {
      position: absolute;
      display: none;
      left: 0;
      top: 0;
      width: 200px;
      height: 200px;
      border: 1px solid #eee;
      background: url("../assets/icon-bk.png") repeat 0 0;
      cursor: move;
      user-select: none;
      opacity: 0.6;
    }
  }
  .zoom-box {
    width: 410px;
    height: 410px;
    overflow: hidden;
    position: absolute;
    left: 435px;
    border: 1px solid #eee;
    top: 0;
    z-index: 999;
    img {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
.detailsLeft {
  width: 406px;
  height: 70px;
  padding: 20px;
}
.detailSmall,
.jcarousel-panel {
  position: relative;
}
.jcarousel-panel {
  width: 400px;
  overflow: hidden;
}
.jcarousel-panel ul {
  width: 20000em;
  position: relative;
  list-style: none;
  margin: 0;
  padding: 0;
}

.jcarousel-control-next,
.jcarousel-control-prev {
  position: absolute;
  top: 23px;
  width: 20px;
  height: 20px;
  text-align: center;
  color: #f18e3d;
  text-decoration: none;
  font: 40px/16px Arial, sans-serif;
}
.jcarousel-control-next.inactive,
.jcarousel-control-prev.inactive {
  opacity: 0.5;
  cursor: default;
}
.jcarousel-control-prev {
  left: -25px;
}
.jcarousel-control-next {
  right: -25px;
}
.detailSmall li img {
  width: 60px;
  height: 60px;
  border: none;
  vertical-align: top;
}
.detailSmall li {
  float: left;
  padding: 4px;
  margin-right: 12.5px;
  border: 1px solid #e7e7e7;
  cursor: pointer;
}

.detailSmall .click,
.detailSmall li:hover {
  padding: 3px;
  border: 2px solid #ed6c00;
}
.detailSmall a:hover {
  color: #f60;
}
</style>